(function($, undefined) {
	
	'use strict';
	var utils;
	var formValidator;
	var customSelect;
    
    var preventDefault = function(e) {
        e.preventDefault();
    };

	var validateAccount = function() {
		var btn = $(this);
		var form = btn.closest('form');

		var url = '/action/updatePerson';

		url += '?id=' + form.find('input[name=personId]').val();
		url += '&field10=account-validated';
		url += '&ajax=true';

		btn.addClass('disabled');
			
		var obj = ajax(url,function (response) {
			if (response.indexOf('success') !== -1) {
				btn.slideUp();
				formValidator.showSuccessPopup('account-validated-success');
			}
		},true);
	};

	var toggleSubscription = function() {
		var btn = $(this);
		var form = btn.closest('form');

		var url = '/action/shopAdminUpdateSubscription';

		url += '?id=' + form.find('input[name=id]').val();
		url += '&active=' + !btn.hasClass('disable');
		url += '&ajax=true';

		btn.addClass('disabled');
			
		var obj = ajax(url,function (response) {
			btn.hasClass('disable') ? btn.removeClass('disable').html(form.attr('data-enable')) : btn.addClass('disable').html(form.attr('data-disable'));
			
			if (response.indexOf('success') !== -1) {
				window.location.reload();
			}
			btn.removeClass('disabled');
		},true);
	};

	var updateSubscription = function() {
		var btn = $(this);
		var form = btn.closest('form');

		var data = {
			ajax: true
		};

		if (form.find('input[name=id]').length !== 0) {
			data.id = form.find('input[name=id]').val();
		}
		if (form.find('input[name=personId]').length !== 0) {
			data.personId = form.find('input[name=personId]').val();
		}
		if (form.find('.form-select[name=quantity]').length !== 0) {
			data.quantity = parseInt(customSelect.val(form.find('.form-select[name=quantity]').closest('.select-changed-js')));
		}
		if (form.find('.form-select[name=productId]').length !== 0) {
			data.productId = customSelect.val(form.find('.form-select[name=productId]').closest('.select-changed-js'));
		}
		if (form.find('.form-select[name=plan]').length !== 0) {
			data.plan = customSelect.val(form.find('.form-select[name=plan]').closest('.select-changed-js'));
		}
		if (form.find('input[name=expiration]').length !== 0) {
			var expDate = form.find('input[name=expiration]').val().split('-');
			data.expirationDay = expDate[0];
			data.expirationMonth = expDate[1] - 1;
			data.expirationYear = expDate[2];
		}
		if (form.find('input[name=field13]').length !== 0 && form.find('input[name=field13]').val().length !== 0) {
			data.field13 = form.find('input[name=field13]').val();
		}
		if (form.find('input[name=field17]').length !== 0 && form.find('input[name=field17]').val().length !== 0) {
			data.field17 = form.find('input[name=field17]').val();
		}

		btn.addClass('disabled');

		$.ajax({
			url: '/action/shopAdminUpdateSubscription',
			cache: false,
			method: 'POST',
			data: data,
			success: function (response) {
				if (response.indexOf('success') !== -1) {
					window.location.reload();
				}
				btn.removeClass('disabled');
			}
		});
	};
	
		
	var saveNotificationLabel = function() {
		var btn = $(this);
		var lang = $('html').attr('lang');
		var label = btn.attr('data-label');
		var value = "";
		
		var row = btn.closest('tr');
		var textParts = row.find('td').eq(1).find('span').not('.link-label');
		
		var tokenCounter = 0;
		textParts.each(function(i, el) {
			if (i > 0) {
				value += " ";
			}
			if ($(el).hasClass('token')) {
				value += "%" + ++tokenCounter + "%";
			}
			else {
				value += $(el).text();
			}
		});
		
		value = value.replace(/\s([\s,\.;:!?])/g, "$1"); // remove double space and space before punctuation
		
		updateLabel(label, value.trim(), lang, function(response) {
			utils.animateCheck('success', btn);
		}, true);
	};
	
	var createAccount = function(captcha) {
        var t = $(this);
        var form = t.closest('form');
        var popup = t.closest('.popup');

        if (t.hasClass('disabled')) {
            return;
        }

        formValidator.validateForm(form);
        if (form.hasClass('has-error')) {
            grecaptcha.reset(t.attr('data-widget-id'));
            return;
        }
        t.addClass('disabled');
        popup.addClass('is-processing');

        var data = {
            "email": $('.form-input[name="email"]', form).val(),
            "password": $('input[name="password"]', form).val(),
            "firstName": $('.form-input[name="firstName"]', form).val(),
            "lastName": $('.form-input[name="lastName"]', form).val(),
            "field1": $('.form-input[name="account-type"]', form).val(),
            "field16": 'change-pw',
            "ajax": true,
            "captcha": captcha
        };

        $.ajax({
            url: '/action/createAccount',
            type: 'POST',
            cache: false,
            data: data,
            success: function(response) {
                if (response.indexOf('success') !== -1) {
                    window.location.href = $('input[name="forward"]', form).val();
                } else if (response.indexOf('fail') !== -1) {
                    formValidator.showErrorPopupAnimation('email-error');
                    popup.removeClass('is-processing');
                    t.removeClass('disabled');
                    grecaptcha.reset(t.attr('data-widget-id'));
                }
            }
        });
    };
	
	var init = function () {
		utils = Fw.component.models().utils;
		formValidator = Fw.component.models().form;
		customSelect = Fw.component.models().customSelect;

		$('.validate-account-btn').click(validateAccount);
		$('.toggle-subscription-status-btn').click(toggleSubscription);
		$('.update-subscription-btn').click(updateSubscription);
		$('.save-notification-label-btn').on('click', saveNotificationLabel);
        
        $('.create-account-btn').each(function(i, el) {
            $(el).closest('form').on('submit', preventDefault);
            Fw.component.models().utils.recaptcha2(el, createAccount);
        });
        
		$('.mg2-admin-db-btn-hijack').on('click', function() {
			$(this).closest('.processing-loader').addClass('is-processing');
		});
	};

	
	$(init);
	
})(jQuery);
